var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAzureDndSmallDisabled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .azure-disabled{fill:#c8c8c8}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_sync_azure_40_disabled",
    transform: "translate(0.5 0.5)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_64",
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#fff",
    stroke: "#e8e8e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M6.986 6.986H0V0h6.986z",
    className: "azure-disabled",
    transform: "translate(12.667 12.667)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-2",
    d: "M183.986 6.986H177V0h6.986v6.986z",
    className: "azure-disabled",
    transform: "translate(-156.653 12.667)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-3",
    d: "M6.986 183.986H0V177h6.986z",
    className: "azure-disabled",
    transform: "translate(12.667 -156.653)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-4",
    d: "M183.986 183.986H177V177h6.986v6.986z",
    className: "azure-disabled",
    transform: "translate(-156.653 -156.653)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAzureDndSmallDisabled);
export default __webpack_public_path__ + "static/media/azure-dnd-small-disabled.20a7dc998d5344afab5f42dd91861f4c.svg";
export { ForwardRef as ReactComponent };